import { ReactComponent as Info } from './assets/info.svg';
import { ReactComponent as Email } from './assets/email.svg';
import { ReactComponent as Edit } from './assets/edit.svg';
import { ReactComponent as Layers } from './assets/layers.svg';
import { ReactComponent as Lock } from './assets/lock.svg';
import { ReactComponent as Arrow } from './assets/arrow.svg';
import { ReactComponent as Back } from './assets/back.svg';
import { ReactComponent as CheckPlus } from './assets/check-plus.svg';
import { ReactComponent as Close } from './assets/close.svg';
import { ReactComponent as Check } from './assets/check.svg';
import { ReactComponent as Chevron } from './assets/chevron.svg';
import { ReactComponent as Eye } from './assets/eye.svg';
import { ReactComponent as House } from './assets/house.svg';
import { ReactComponent as Profile } from './assets/profile.svg';
import { ReactComponent as Phone } from './assets/phone.svg';
import { ReactComponent as Warning } from './assets/warning.svg';
import { ReactComponent as Dashboard } from './assets/dashboard.svg';
import { ReactComponent as Search } from './assets/search.svg';
import { ReactComponent as File } from './assets/file.svg';
import { ReactComponent as LogOut } from './assets/logout.svg';
import { ReactComponent as Moon } from './assets/moon.svg';
import { ReactComponent as Bell } from './assets/bell.svg';
import { ReactComponent as FilePlus } from './assets/file-plus.svg';
import { ReactComponent as ExternalLink } from './assets/external-link.svg';
import { ReactComponent as Subtract } from './assets/subtract.svg';
import { ReactComponent as Filter } from './assets/filter.svg';
import { ReactComponent as ChevronLeft } from './assets/chevron-left.svg';
import { ReactComponent as ChevronRight } from './assets/chevron-right.svg';
import { ReactComponent as ChevronsLeft } from './assets/chevrons-left.svg';
import { ReactComponent as ChevronsRight } from './assets/chevrons-right.svg';
import { ReactComponent as Plus } from './assets/plus.svg';
import { ReactComponent as Supplier } from './assets/supplier.svg';
import { ReactComponent as Group } from './assets/group.svg';
import { ReactComponent as Expenses } from './assets/expenses.svg';
import { ReactComponent as Contracts } from './assets/contracts.svg';
import { ReactComponent as Order } from './assets/supplyorder.svg';
import { ReactComponent as CellPhone } from './assets/cell-phone.svg';
import { ReactComponent as CellPhoneCheck } from './assets/cell-phone-check.svg';
import { ReactComponent as Mobile } from './assets/mobile.svg';
import { ReactComponent as Computer } from './assets/computer.svg';
import { ReactComponent as Notebook } from './assets/notebook.svg';
import { ReactComponent as Tablet } from './assets/tablet.svg';
import { ReactComponent as QrCode } from './assets/qr-code.svg';
import { ReactComponent as Headset } from './assets/headset.svg';

export const names = {
  info: Info,
  email: Email,
  layers: Layers,
  edit: Edit,
  lock: Lock,
  arrow: Arrow,
  back: Back,
  checkPlus: CheckPlus,
  check: Check,
  chevron: Chevron,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  chevronsRight: ChevronsRight,
  chevronsLeft: ChevronsLeft,
  close: Close,
  eye: Eye,
  house: House,
  profile: Profile,
  phone: Phone,
  warning: Warning,
  dashboard: Dashboard,
  search: Search,
  file: File,
  plus: Plus,
  logout: LogOut,
  moon: Moon,
  bell: Bell,
  filter: Filter,
  filePlus: FilePlus,
  subtract: Subtract,
  externalLink: ExternalLink,
  supplier: Supplier,
  group: Group,
  expenses: Expenses,
  contracts: Contracts,
  order: Order,
  cellPhone: CellPhone,
  cellPhoneCheck: CellPhoneCheck,
  mobile: Mobile,
  computer: Computer,
  notebook: Notebook,
  tablet: Tablet,
  qrCode: QrCode,
  headset: Headset,
};
